'use client'

import type { PropsWithChildren } from 'react'

import { InfoTooltip } from '@morpho-org/ui-v6/client'

const VaultV2RiskDisclosuresLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="gap-sm flex flex-col" data-testid="vault-v2-risk-disclosures">
      <div className="gap-xs flex items-center">
        <span className="text-foreground text-sm">Risk Disclosures</span>
        <InfoTooltip
          tooltipContent={
            <>
              Shared by the curator, this section outlines the risks associated with the
              vault&apos;s deployed adapters and their configuration.
            </>
          }
          className="text-secondary-foreground hover:text-foreground size-5 transition-colors"
        />
      </div>
      {children}
    </div>
  )
}

export default VaultV2RiskDisclosuresLayout
